module.exports = __webpack_public_path__ + "static/assets/70ac0fb02ab38b02878bcd913e49ecc3.svg";